// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import ImmobiliGrid from "../Properties/ImmobiliGrid";
import ImmobiliList from "../Properties/ImmobiliList";
import { Link } from "react-router-dom";
import {useState, useEffect} from "react";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../config/appConfig";

// HOOKS
import { useGetProperties } from "../../hooks/useGetProperties";

// COMPONENTI
import LoadingIndicator from "../Loaders/LoadingIndicator";

// Interfaccie Tipi
const Vetrina2: React.FC = () => {
    const { t } = useTranslation();

    const { properties, loading, error } = useGetProperties(AGENCY_ID, {
            limit: 4,
            offset: 0,
            withCount: false,
            filters: {
                vetrina: 2
            }
        }
    );

    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // ---- Gestione Stati Iniziali ----
    if (loading) return <LoadingIndicator />;

    if (error) {
        console.error("Errore caricamento Vetrina:", error);
        return <div className="alert alert-warning">{t('common.loadingError', 'Errore caricamento dati.')}</div>;
    }

    if (!properties || properties.length === 0) {
        return (
            <div className="text-center p-5">{t('propertyList.notFound.title')}</div>
        )
    }

    return (
        <section id="vetrina2-box" className="space-ptb">
            <div className="container-fluid w-90">
                <div className="row">
                    <div className="col-12 mb-4">
                        <h3 dangerouslySetInnerHTML={{ __html: t('homePage.vetrina.title') as string }} />
                    </div>
                </div>
            </div>
            <div className="container-fluid w-90">
                <div className="row justify-content-around">
                    {isMobile ? (
                        <ImmobiliGrid
                            properties={properties}
                            loading={loading}
                            error={error}
                            basePath="immobile"
                            labelSold={false}
                        />
                    ) : (
                        <ImmobiliList
                            properties={properties}
                            loading={loading}
                            error={error}
                            basePath="immobile"
                            labelSold={false}
                        />
                    )}
                </div>
                <div className="row">
                    <Link to="/immobili" className="btn btn-primary mx-auto mt-4">
                        <span> {t('homePage.vetrina.btnText')}</span>
                        <span> {t('homePage.vetrina.btnText')}</span>
                    </Link>
                </div>
            </div>
        </section >
    );
};

export default Vetrina2;